import styled from "styled-components";
import { responsive } from "../../../../../../../../styles/constants.style";

export const CoachAssignmentWrapper = styled.div`
  margin: 0px 16px 24px;
  .add-function-header {
    margin: 26px 0 0px 0;
  }
  .add-function-container {
    margin-bottom: 24px;
  }
  .add-function-button {
    padding-top: 31px;

    ${responsive.MOBILE`
      padding-top: 0;
    `}
    button {
      height: 49px;
    }
  }
`;

export const EditCoachAssignmentWrapper = styled.div`
  padding: 24px 16px;
  .assign-coach-fun-label {
    margin-bottom: 40px;
  }
  .assign-coach-control {
    width: 33%;
  }
`;
